/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status:  * `submitted` - Generating of a report was triggered and it will be generated  * `processing` - Report is generated  * `success` - Report has been successfully generated  * `failed` - During generating of the report an error occured no report is generated 
 */
export enum ReportStatusEnumDTO {
    SUBMITTED = 'submitted',
    PROCESSING = 'processing',
    SUCCESS = 'success',
    FAILED = 'failed'
}

export class ClsReportStatusEnumDTO {
    SUBMITTED = 'submitted';
    PROCESSING = 'processing';
    SUCCESS = 'success';
    FAILED = 'failed';
}

